export default __webpack_public_path__ + "static/media/close-thin.c3532fd4.svg";